import useLifecareStudio from '../../hooks/useLifecareStudio';
import LifecareStudioLayout from '../lifecare-studio/LifecareStudioLayout';

const LifecareStudio = () => {
  const studioState = useLifecareStudio();
  return <LifecareStudioLayout studioState={studioState} />;
};

export default LifecareStudio;
